import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MemberHeader.scss';

const MemberHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="member-header">
      <div className="member-header-container">
        <Link to="/dashboard" className="member-logo">
          <img src="/assets/IMG/logo_transparent.png" alt="BE TALENTED" />
          <span>Espace Membre</span>
        </Link>

        <nav className="member-nav">
          <Link to="/dashboard" className="member-nav-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7"/>
              <rect x="14" y="3" width="7" height="7"/>
              <rect x="14" y="14" width="7" height="7"/>
              <rect x="3" y="14" width="7" height="7"/>
            </svg>
            Tableau de bord
          </Link>
          <span className="member-nav-link member-nav-link--disabled" title="Bientôt disponible">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
            Mes Programmes
          </span>
          <span className="member-nav-link member-nav-link--disabled" title="Bientôt disponible">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="7"/>
              <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
            </svg>
            Certificats
          </span>
          <span className="member-nav-link member-nav-link--disabled" title="Bientôt disponible">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            Ma Carte
          </span>
          <Link to="/member/profil" className="member-nav-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            Mon Profil
          </Link>
        </nav>

        <div className="member-user-menu">
          <div className="member-user-info">
            <div className="member-user-avatar">
              {user?.photo
                ? <img src={user.photo} alt={`${user.prenom} ${user.nom}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                : <>{user?.prenom?.charAt(0)}{user?.nom?.charAt(0)}</>
              }
            </div>
            <div className="member-user-details">
              <span className="member-user-name">{user?.prenom} {user?.nom}</span>
              <span className="member-user-role">Membre</span>
            </div>
          </div>
          <button onClick={handleLogout} className="member-logout-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Déconnexion
          </button>
        </div>
      </div>
    </header>
  );
};

export default MemberHeader;
